import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
    static targets = ["multiselect", "selectedList", "count"];

    connect() {
        this.$select = $(this.multiselectTarget);

        if (!this.$select.hasClass("select2-hidden-accessible")) {
            let config = this.parseConfig(this.multiselectTarget.dataset.pos || '{}');

            if (config.ajax) {
                config.ajax.data = function(params) {
                    return { q: params.term };
                };

                config.ajax.processResults = function(data) {
                    return { results: data };
                };
            }

            this.$select.select2(config);
        }

        this.$select.on("select2:select select2:unselect", () => {
            this.updateCount();
        });

        this.updateCount();
    }

    parseConfig(posData) {
        try {
            const jsonString = posData.replace(/&quot;/g, '"');
            return JSON.parse(jsonString);
        } catch (e) {
            console.error("Failed to parse Select2 config JSON:", e);
            return {};
        }
    }

    updateCount() {
        if (!this.hasCountTarget) return;

        const selectedCount = (this.$select.val() || []).length;
        const listingsText = this.countTarget.textContent.replace(/\d+/, selectedCount);

        this.countTarget.textContent = listingsText;
    }

    removeItem(event) {
        event.preventDefault();

        const itemId = event.currentTarget.dataset.id;
        if (!itemId) return;

        const values = this.$select.val() || [];
        const newValues = values.filter(val => val !== itemId);
        this.$select.val(newValues).trigger("change");

        const el = event.currentTarget.closest(".flex.items-center.justify-between");
        if (el) el.remove();

        this.updateCount();
    }
}
